
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gray-dark text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Company Info */}
          <div>
            <h3 className="text-base font-medium mb-4">おかやま脱毛サロン・エステ</h3>
            <ul className="space-y-3 text-sm font-light text-gray-light/80">
              <li>
                <strong className="text-white">住所:</strong> 岡山県岡山市北区表町1-2-3
              </li>
              <li>
                <strong className="text-white">TEL:</strong> 086-012-3456
              </li>
              <li>
                <strong className="text-white">FAX:</strong> 086-012-3457
              </li>
              <li>
                <strong className="text-white">営業時間:</strong> 9:00 - 18:00
              </li>
              <li>
                <strong className="text-white">定休日:</strong> 日曜日・祝日
              </li>
            </ul>
          </div>

          {/* Site Map */}
          <div>
            <h3 className="text-base font-medium mb-4 uppercase tracking-wider">サイトマップ</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-sm font-light text-gray-light/80 hover:text-white transition-colors">
                  トップ
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm font-light text-gray-light/80 hover:text-white transition-colors">
                  当店について
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-sm font-light text-gray-light/80 hover:text-white transition-colors">
                  サービス・料金案内
                </Link>
              </li>
              <li>
                <Link to="/company" className="text-sm font-light text-gray-light/80 hover:text-white transition-colors">
                  会社概要
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm font-light text-gray-light/80 hover:text-white transition-colors">
                  予約・お問い合わせ
                </Link>
              </li>
            </ul>
          </div>

          {/* LINE Reservation */}
          <div>
            <h3 className="text-base font-medium mb-4 uppercase tracking-wider">LINE予約</h3>
            <a
              href="https://line.me/R/"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="inline-flex items-center justify-center px-6 py-3 bg-white text-gray-dark text-sm font-medium rounded-lg hover:bg-gray-light/90 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-line-fill mr-2 w-5 h-5 flex items-center justify-center"></i>
              LINEで予約はこちら
            </a>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-light/20">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm font-light text-gray-light/60">
              &copy; 2026 おかやま脱毛サロン・エステ株式会社. All rights reserved.
            </p>
            <a
              href="https://readdy.ai/?ref=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm font-light text-gray-light/60 hover:text-white transition-colors cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
